import { Component, Input, ViewChild, Injector } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Store } from '@ngrx/store';
import { Pagination, PermissionAssigneeTargetLinkContainerModel, PermissionSetService, PermissionTemplateService, TenantPermissionAssigneeTargetService } from 'blg-akaun-ts-lib';
import { fetchAllByCriteria } from '../../../../../../listing.utils';
import { PermissionFacade } from '../../../../../../modules/permission/facades/permission.facade';
import { RolePermSetListingSearchModel } from '../../../../../../models/advanced-search-models/role-perm-set-listing-search.model';
import { RolePermSetModel } from '../../../../../../models/role-permissions.model';
import { gridOptionsClientSide } from '../../../../../../listing.utils';
import { PaginationComponent } from '../../../../../../utilities/pagination/pagination.component';
import { ViewColumnComponent } from '../../../../../../view-column.component';
import { AppConfig } from '../../../../../../visa';
import { forkJoin, Observable, of } from 'rxjs';
import { filter, map, mergeMap, switchMap, catchError, take } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { PermissionStates } from '../../../../permission-controller/root';
import { RolePermActions } from '../../../../role-permissions-controller/actions';
import { RolePermSelectors } from '../../../../role-permissions-controller/selectors';
import { SearchQueryModel } from '../../../../../../models/query.model';
import { SessionSelectors } from '../../../../../../modules/session/session-controller/selectors';
import { SessionStates } from '../../../../../../modules/session/session-controller/states';
import { TranslateService } from "@ngx-translate/core";

interface LocalState {
  deactivateReturn: boolean;
  selectedIndex: number;
  deactivateAdd: boolean;
  deactivateList: boolean;
}

@Component({
  selector: 'app-role-permission-set',
  templateUrl: './role-permission-set.component.html',
  styleUrls: ['./role-permission-set.component.scss']
})

export class RolePermissionSetComponent extends ViewColumnComponent {

  @ViewChild(PaginationComponent, {static: false})
  private paginationComponent: PaginationComponent;
  @Input() selectedIndex;

  protected readonly index = 2;
  private localState: LocalState;

  // initialise local states
  readonly localState$ = this.viewColFacade.selectLocalState(this.index);
  readonly deactivateAdd$ = this.componentStore.select(state => state.localState.deactivateAdd);
  readonly deactivateList$ = this.componentStore.select(state => state.localState.deactivateList);

  // api visa
  apiVisa = AppConfig.apiVisa;

  // subSink is to ensure all subscribe calls are unsubscribed to once the component is destroyed
  private subSink = new SubSink;

  searchModel = RolePermSetListingSearchModel;

  // initial ag grid state
  gridApi;
  gridOptions = gridOptionsClientSide;
  columnsDefs;
  rowSelection = 'multiple';
  tenantGuid;

  rowData = [
    // {
    //   app_perm_set_hdr: {guid: 1, code: "example code 1", name: "Create delivery order for South East branch"},
    //   app_perm_template_hdr: {name: 'Create delivery order perm Dfn Template'}
    // },
    // {
    //   app_perm_set_hdr: {guid: 2, code: "example code 2", name: "Create sales order for Johor branches"},
    //   app_perm_template_hdr: {name: 'Create sales order perm Dfn Template'}
    // },
    // {
    //   app_perm_set_hdr: {guid: 3, code: "example code 3", name: "Create delivery order  for Johor branches"},
    //   app_perm_template_hdr: {name: 'Create delivery order for Penang branch'}
    // }
  ];

  // this applet guid
  appletGuid: string = sessionStorage.getItem('appletGuid');
  roleGuid: string;

  //translation variable
  perm_set_code_text: string;
  perm_set_name_text: string;
  perm_template_name_text: string;
  create_button: string;
  remove_button: string;

  constructor(
    private permSetService: PermissionSetService,
    private tenantPermAssigneeTargetLinkService: TenantPermissionAssigneeTargetService,
    private permTemplateService: PermissionTemplateService,
    private readonly store: Store<PermissionStates>,
    private viewColFacade: PermissionFacade,
    private readonly sessionStore: Store<SessionStates>,
    private componentStore: ComponentStore<{localState: LocalState}>,
    private injector: Injector
  ) {
    super();
    const translateService = this.injector.get(TranslateService, null);
    if (translateService) {
      translateService.get('labels').subscribe(res => {
        this.perm_set_code_text = res.perm_set_code;
        this.perm_set_name_text = res.perm_set_name;
        this.perm_template_name_text = res.perm_template_name;
        this.create_button = res.create_button_nocaps;
        this.remove_button = res.remove_button_caps;
      });
    } else {
      this.perm_set_code_text = 'Perm Set Code';
      this.perm_set_name_text = 'Perm Set Name';
      this.perm_template_name_text = 'Perm Template Name';
      this.create_button = 'Create';
      this.remove_button = 'REMOVE';
    }
  }

  /**
   * Lifecycle method: Called when component is first initialised.
   */
   ngOnInit() {
    // initial configurations for local state
    this.subSink.sink = this.localState$.subscribe( a => {
      this.localState = a;
      this.componentStore.setState( {localState: a} );
    });

    this.subSink.sink = this.store.select(RolePermSelectors.selectGuid).subscribe(guid => {
      if (guid) {
        this.roleGuid = guid;
      }
    });

    const AppletLoginSubjectLink$ = this.sessionStore.select(SessionSelectors.selectAppletLoginSubjectLink);

    this.subSink.sink = AppletLoginSubjectLink$.subscribe(session => {
      if(session) {
        console.log("Session tenant guid: ",session);
        this.tenantGuid = session.tenant_guid.toString();
      }
    })

    this.columnsDefs = [
      {
        headerName: '',
        field: 'app_perm_set_hdr.guid',
        valueFormatter: params => '',
        checkboxSelection: true,
        headerCheckboxSelection: true,
        floatingFilter: false,
        sortable: false,
        minWidth: 0
      },
      {
        headerName: this.perm_set_code_text,
        field: 'app_perm_set_hdr.code',
        cellStyle: {textAlign: 'left'}
      },
      {
        headerName: this.perm_set_name_text,
        field: 'app_perm_set_hdr.name',
        cellStyle: {textAlign: 'left'}
      },
      {
        headerName: this.perm_template_name_text,
        field: 'app_perm_template_hdr.name',
        cellStyle: {textAlign: 'left'}
      }
    ]
  }

  /**
   * This function is called when the user clicks on the Add button in the UI.
   * Will trigger the add component to be shown on the screen.
   *
   */
   onNext() {
    console.log("selectedIndex", this.selectedIndex);
    // deactivate return, add and list in this component
    this.viewColFacade.updateInstance(this.index,
      {
        ...this.localState,
        deactivateReturn: true,
        deactivateAdd: true,
        deactivateList: true,
        selectedIndex: 2
      });
    // trigger the add permission set component to be shown
    this.viewColFacade.onNextAndReset(this.index, 5);
  }

  /**
   * This function is called when AG grid is first initialised and initally
   * sets the datasource of the grid.
   *
   * @param params : grid parameters
   */
   onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.closeToolPanel();

    this.getPermSetsInRole();

    // resize columns
    const allColIds = params.columnApi.getAllColumns().map(x => x.colId);
    params.columnApi.autoSizeColumns(allColIds);

    this.subSink.sink = this.store.select(RolePermSelectors.selectUpdateAllPermSetListing)
    .pipe(
      filter(x => x),
      switchMap(() => this.store.select(RolePermSelectors.selectGuid).pipe(take(1))),
      filter(guid => !!guid) // Ensure guid is not null or undefined
    )
    .subscribe(guid => {
      this.roleGuid = guid;
      console.log("this.roleGuid", this.roleGuid);
      this.getPermSetsInRole();
      this.store.dispatch(RolePermActions.setUpdateAllPermSetListing({ update: false }));
    });
  }

  /**
   * Returns the datasource for the AG grid.
   *
   * @param conditionalCriteria : any custom criteria to search for in the API
   * @returns the datasource
   */
  getDatasource(conditionalCriteria?) {
    let criteria = [
      { columnName: 'calcTotalRecords', operator: '=', value: 'true' },
      ...(conditionalCriteria || [])
    ];

    const pagination = new Pagination(
      0,
      10000,
      criteria
    );

    this.subSink.sink = this.permSetService.getByCriteria(pagination, this.apiVisa)
      .pipe(
        mergeMap(response => {
          const enrichedData$ = response.data.map(record =>
            this.enrichWithPermissionTemplates(record)
          );

          return forkJoin(enrichedData$).pipe(
            map(data => ({ ...response, data })),
            catchError(err => {
              console.error('Error in enrichment:', err);
              return of({ ...response, data: [] });
            })
          );
        }),
        catchError(err => {
          console.error('Error fetching data:', err);
          return of({ data: [], totalRecords: 0 });
        })
      )
      .subscribe(response => {
        this.rowData = response.data;
        this.gridApi.setRowData(response.data);
      }, err => {
        console.error('Error in subscription:', err);
      });
  }

  private enrichWithPermissionTemplates(record): Observable<RolePermSetModel> {
    const newModel = new RolePermSetModel();
    newModel.app_perm_set_hdr = record.app_perm_set_hdr;
    newModel.app_perm_set_lines = record.app_perm_set_lines;

    return this.getPermTemplate(
      record.app_perm_set_hdr.parent_guid.toString(),
      this.appletGuid,
      this.tenantGuid
    ).pipe(
      map(template => {
        if (template?.app_perm_template_hdr) {
          newModel.app_perm_template_hdr = template.app_perm_template_hdr;
        }
        return newModel;
      }),
      catchError(err => {
        console.error('Error fetching permission template:', err);
        return of(newModel);
      })
    );
  }


  /**
   * Returns all the guids of all the permission sets in this role.
   *
   */
  getPermSetsInRole() {
    /**
     * Replaces the raw SELECT that went through SubQueryService:
     *
     *   FROM app_perm_set_hdr hdr
     *   INNER JOIN app_perm_assignee_target_link link ON hdr.guid = link.perm_set_hdr_guid
     *   WHERE link.assignee_hdr_table = 'app_mst_role'
     *     AND link.assignee_hdr_guid = '<role>'
     *     AND hdr.applet_guid = '<applet>'
     *     AND hdr.status != 'DELETED' AND link.status != 'DELETED'
     *
     * AppPermissionSetUow.generateWhereClauseByCriteria performs the same join
     * and applies `assignee_hdr_table`, `assignee_hdr_guid` and `applet_guid` as
     * criteria, with `status != 'DELETED'` as its default on both tables.
     */
    this.getDatasource(this.buildSearchCriteria());
  }

  /**
   * Returns an observable containing the permission template with this guid.
   *
   * @param guid : guid of the permission template
   * @returns an observable of the permission template
   */
 getPermTemplate(guid, appletGuid: string, tenantGuid: string) {
  return this.permTemplateService.getByLogin(appletGuid, tenantGuid, this.apiVisa)
    .pipe(
      map(a => a.data), // Extract data property
      map(data => this.filterData(guid, data)) // Apply your filtering logic
    );
}

// Add a custom filterData function to filter the data
filterData(guid: string, data: any): any {
  // Use the equality operator (===) for comparison
  let filteredData = data.filter(item => item.app_perm_template_hdr.guid === guid);
  return filteredData[0];
}

  // getPermTemplate(guid: string) {
  //   return this.permTemplateService.getByGuid(guid, this.apiVisa)
  //     .pipe(
  //       map(a => a.data)
  //     )
  // }

  /**
   * This function is called every time the user searches something in the
   * search bar.
   *
   * @param e : the search model
   */
   /**
   * Runs the search bar's query against the permission-set listing's own
   * endpoint.
   *
   * Replaces the raw SQL that <app-advanced-search> built from
   * RolePermSetListingSearchModel and posted to SubQueryService (a SELECT over
   * app_perm_set_hdr INNER JOINed to app_perm_assignee_target_link and
   * app_perm_template_hdr, with the assignee and applet scoping appended here).
   * The search bar is now <app-advanced-search-general>, which emits the keyword
   * and the form value instead of SQL.
   *
   * AppPermissionSetUow.generateWhereClauseByCriteria makes both joins itself and
   * honours `search_word` (bound ILIKE over the header's code and name),
   * `perm_template` (ILIKE on the joined template's name), `applet_guid`, and
   * `assignee_hdr_table` / `assignee_hdr_guid` for the link scoping -- the fields
   * added to AppPermissionSetQueryCriteria for exactly this move.
   *
   * The assignee and applet scoping the old SQL carried is re-seeded on every
   * search, so a search never widens the listing beyond this role and applet.
   */
  onSearch(e: SearchQueryModel) {
    this.getDatasource(this.buildSearchCriteria(e));
  }

  /**
   * Criteria for the permission sets assigned to this role in this applet, plus
   * whatever the search bar asked for.
   */
  buildSearchCriteria(e?: SearchQueryModel) {
    const criteria: any[] = [
      { columnName: 'assignee_hdr_table', operator: '=', value: 'app_mst_role' },
      { columnName: 'assignee_hdr_guid', operator: '=', value: this.roleGuid },
      { columnName: 'applet_guid', operator: '=', value: this.appletGuid }
    ];
    if (!e || e.isEmpty) {
      return criteria;
    }
    if (e.keyword) {
      return criteria.concat([
        { columnName: 'search_word', operator: '=', value: e.keyword.trim() }
      ]);
    }
    const query: any = e.queryString || {};
    return criteria.concat(
      [{ columnName: 'perm_template', operator: '=', value: query.permTemplate }]
        .filter(condition => condition.value)
    );
  }

  /**
   * Remove the selected permission sets from the role (including all the perm
   * assignee target links).
   */
  /**
   * Remove the selected permission sets from the role (including all the perm
   * assignee target links).
   *
   * Replaces the raw SELECT that went through SubQueryService:
   *
   *   FROM app_perm_assignee_target_link link
   *   WHERE link.assignee_hdr_table = 'app_mst_role'
   *     AND link.assignee_hdr_guid = '<role>'
   *     AND link.applet_hdr_guid = '<applet>'
   *     AND (link.perm_set_hdr_guid = '<a>' OR link.perm_set_hdr_guid = '<b>' ...)
   *     AND link.status != 'DELETED'
   *
   * GET permission-assignee-target/query ->
   * PermissionAssigneeTargetLinkUow.generateWhereClauseByCriteria honours
   * `assignee_hdr_table`, `assignee_hdr_guid`, `applet_hdr_guid` and
   * `perm_set_hdr_guids` -- the last of which expresses the OR chain over the
   * selected permission sets as an IN list -- and defaults to
   * `status != 'DELETED'`.
   *
   * fetchAllByCriteria pages until the endpoint stops returning full pages, so
   * every link for the selected permission sets is removed. Stopping at one page
   * would leave residual permissions behind, which the raw subquery never did.
   */
  onRemove() {
    const permSetGuids = this.gridApi.getSelectedNodes()
      .map(node => node.data.app_perm_set_hdr.guid.toString());
    if (!permSetGuids.length) {
      return;
    }
    this.subSink.sink = fetchAllByCriteria<PermissionAssigneeTargetLinkContainerModel>(
      pagination => this.tenantPermAssigneeTargetLinkService.getByCriteria(pagination, this.apiVisa),
      [
        { columnName: 'assignee_hdr_table', operator: '=', value: 'app_mst_role' },
        { columnName: 'assignee_hdr_guid', operator: '=', value: this.roleGuid },
        { columnName: 'applet_hdr_guid', operator: '=', value: this.appletGuid },
        { columnName: 'perm_set_hdr_guids', operator: '=', value: permSetGuids.toString() }
      ]
    ).subscribe(links => {
      const guids = links.map(link => link.permAssigneeTargetLink.guid.toString());
      // dispatch ngrx action to remove permission sets
      this.store.dispatch(RolePermActions.removePermSetsFromRoleInit({guids}));
    })
  }

  /**
   * Lifecycle method: Called when component is destroyed.
   */
   ngOnDestroy() {
    this.subSink.unsubscribe();
  }

}
